import { Component, EventEmitter, Output } from '@angular/core';
import { IconSize } from '../core-data-model/IconSize';
import { IconType } from '../core-data-model/IconType';
import { TranslationService } from '../translations/Translation.service';

@Component({
    selector: 'third-party-access-enable-modal',
    template: `
        <modal class="pi-modal">
            <div class="pi-modalHeader move-right layoutLastPushedRight-X">
                <div class="cardTitle">
                    <abstract-icon
                        [iconType]="IconType.Warning2"
                        [iconSize]="IconSize.M_large"
                    >
                    </abstract-icon>
                    {{
                        TR.key('thirdPartyUser.enableAccess-confirmationHeader')
                    }}
                </div>
                <button
                    type="button"
                    class="close"
                    (click)="modalClosed.emit()"
                    [title]="TR.key('text.common-terms.close')"
                >
                    <abstract-icon [iconType]="IconType.Close"> </abstract-icon>
                </button>
            </div>
            <div class="pi-modalBody" style="min-height:0;">
                <div style="margin-top:15px;">
                    {{
                        TR.key(
                            'thirdPartyUser.enableAccess-confirmationMessage'
                        )
                    }}
                </div>
            </div>
            <div class="pi-modal pi-modalContent pi-modalFooter">
                <button
                    class="button button-link button-md"
                    (click)="modalClosed.emit()"
                >
                    {{
                        TR.key(
                            'administration.anonymization.singlePerson.noCancelButton'
                        )
                    }}
                </button>
                <button
                    class="button button-primary button-md"
                    (click)="performAction.emit()"
                >
                    {{
                        TR.key('thirdPartyUser.enableAccess-confirmationButton')
                    }}
                </button>
            </div>
        </modal>
    `,
    standalone: false
})
export class ThirdPartyAccessModalComponent {
    @Output()
    readonly modalClosed = new EventEmitter();
    @Output()
    performAction = new EventEmitter();

    IconType = IconType;
    IconSize = IconSize;

    cards = [
        {
            title: this.TR.key('label.common-terms.basic'),
            text: this.TR.key('assessment.job.cognitive.one-point-explanation')
        },
        {
            title: this.TR.key('label.common-terms.intermediate'),
            text: this.TR.key('assessment.job.cognitive.two-point-explanation')
        },
        {
            title: this.TR.key('label.common-terms.advanced'),
            text: this.TR.key(
                'assessment.job.cognitive.three-point-explanation'
            )
        },
        {
            title: this.TR.key('label.common-terms.none'),
            text: this.TR.key('assessment.job.cognitive.zero-point-explanation')
        }
    ];

    constructor(public TR: TranslationService) {}
}
